export default __webpack_public_path__ + "static/Roobert-Bold-cae77e34ae236de1ec540196ca08a09c.ttf";